import { useState } from "react";
import { DateTime } from "luxon";

import { TimePicker } from "../../../components/TimePicker/TimePicker";
import { anchorTimeInShift, movementTimeInZone, ShiftWindow } from "../movementEntry";

type MovementTimeSelectProps = {
  movementTimeUtc?: DateTime | string
  shiftWindow: ShiftWindow
  zone: string
  disabled: boolean
  onChange: (movementTimeUtc: string) => unknown
  /** Hold the time until it is finished rather than publishing every clock step, for a cell that saves. */
  saveOnAccept?: boolean
}

const MovementTimeSelect: React.FC<MovementTimeSelectProps> = ({
  movementTimeUtc,
  shiftWindow,
  zone,
  disabled,
  onChange,
  saveOnAccept = false
}) => {
  const [draft, setDraft] = useState<DateTime | null>(null);
  const [isWorking, setIsWorking] = useState(false);

  const publish = async (picked?: DateTime) => {
    if (!picked) return;
    setIsWorking(true);
    await onChange(anchorTimeInShift(picked, shiftWindow).toUTC().toISO()!);
    setIsWorking(false);
    setDraft(null);
  };

  return (
    <TimePicker
      label="Time"
      disabled={disabled || isWorking}
      initialDate={draft ?? (movementTimeUtc ? movementTimeInZone(movementTimeUtc, zone) : null)}
      minValue={shiftWindow.start}
      maxValue={shiftWindow.end}
      onChange={saveOnAccept ? (picked) => setDraft(picked ?? null) : publish}
      onAccept={saveOnAccept ? publish : undefined}
    />
  );
};

export default MovementTimeSelect;
